export type GevelbevestigingUnitData = {
    schadeOpGevelBinnen1mVanGevelbevestiging?: boolean | undefined;
    belemmerendeBelastendeBegroeiingBijOverspanningsinstallatie?: boolean | undefined;
    schadeAanMuurplaat?: boolean | undefined;
    onjuisteMontage?: boolean | undefined;
    moerNietVolledigOverDraadeind?: boolean | undefined;
    ontbrekendeBevestigingsmaterialen?: boolean | undefined;
    totaalKracht?: number | undefined;
    gemetenVoorspanning?: number | undefined;
    toegepasteAdditioneleTrekkracht?: number | undefined;
    gevelverbindingGefaald?: boolean | undefined;
    additioneleTrekkrachtWaarbijGevelverbindingFaalde?: number | undefined;
    opmerking?: string | undefined;

    fotoBestanden?: { assetId: string; description?: string | undefined }[];

    straatBagMutatie?: string | undefined;
    typeGedetailleerdMutatie?: string | undefined;
    opmerkingMutatie?: string | undefined;
    huisnummerMutatie?: string | undefined;
    verdiepingMutatie?: string | undefined;
    latitudeMutatie?: number | undefined;
    longitudeMutatie?: number | undefined;
    aanleghoogteMutatie?: number | undefined;
};

export type GevelbevestigingUnitBasisgegevens = {
    straatbag?: string | undefined;
    aanleghoogte?: number | undefined;
};

export type AansluitkastUnitData = {
    schadeAanAansluitkabel?: boolean | undefined;
    onjuisteMontageAanSpandraad?: boolean | undefined;
    onjuisteMontageAanGevel?: boolean | undefined;
    schadeAanAansluitkast?: boolean | undefined;
    stickerMetIdentificatienummerOnbruikbaarOnleesbaar?: boolean | undefined;

    opmerking?: string | undefined;

    fotoBestanden?: { assetId: string; description?: string | undefined }[];

    straatBagMutatie?: string | undefined;
    lichtpuntnummerMutatie?: string | undefined;
    latitudeMutatie?: number | undefined;
    longitudeMutatie?: number | undefined;
    idtechviewMutatie?: string | undefined;
    stijgbuisZichtbaarMutatie?: boolean | undefined;
    opmerkingMutatie?: string | undefined;
};

export type AansluitkastUnitBasisgegevens = {
    idtechview?: string | undefined;
    lichtpuntnummer?: string | undefined;
    straatbag?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
};

export type MastbevestigingUnitData = {
    schadeAanMast?: boolean | undefined;
    ontbrekendeOnderdelenAanMast?: boolean | undefined;
    hoekVanSpanmast?: number | undefined;
    schadeAanMastopzetstuk?: boolean | undefined;
    ontbrekendeOnderdelenAanMastbeugel?: boolean | undefined;
    schadeAanMastbeugel?: boolean | undefined;

    opmerking?: string | undefined;

    fotoBestanden?: { assetId: string; description?: string | undefined }[];

    straatBagMutatie?: string | undefined;
    typeGedetailleerdMutatie?: string | undefined;
    opmerkingMutatie?: string | undefined;
    latitudeMutatie?: number | undefined;
    longitudeMutatie?: number | undefined;
    aanleghoogteMutatie?: number | undefined;
};

export type MastbevestigingUnitBasisgegevens = {
    straatbag?: string | undefined;
    idmast?: string | undefined;
    aanleghoogte?: number | undefined;
};

export type SpandraadsysteemUnitData = {
    schadeAanSpandraad?: boolean | undefined;
    objectenVanDerdenAanSpandraadBevestigd?: boolean | undefined;
    schadeAanGaffelterminal?: boolean | undefined;
    ontbrekendeOnderdelenAanGaffelterminal?: boolean | undefined;
    onjuisteMontage?: boolean | undefined;
    schadeAanSpandraadklem?: boolean | undefined;
    schadeAanKnoop?: boolean | undefined;

    opmerking?: string | undefined;

    fotoBestanden?: { assetId: string; description?: string | undefined }[];

    straatBagMutatie?: string | undefined;
    typeGedetailleerdMutatie?: string | undefined;
    opmerkingMutatie?: string | undefined;
};

export type SpandraadsysteemUnitBasisgegevens = {
    straatbag?: string | undefined;
};

export type ArmatuurUnitData = {
    schadeAanArmatuur?: boolean | undefined;

    opmerking?: string | undefined;

    fotoBestanden?: { assetId: string; description?: string | undefined }[];

    straatBagMutatie?: string | undefined;
    leverancierstypeMutatie?: string | undefined;
    reedsVoorzienVanLed?: boolean | undefined;
    opmerkingMutatie?: string | undefined;
};

export type ArmatuurUnitBasisgegevens = {
    straatbag?: string | undefined;
    leverancierstype?: string | undefined;
};
